<script>
import Form from "@/components/form/Form.vue";
export default {
  components: {
    Form
  }
};
</script>
<template>
  <main>
    <Form />
  </main>
</template>
